/* =============================================
   SHELL SACKS — theme.js
   Cart + UI interactions
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ===== CART STATE (Shopify Ajax API) =====
  function openCart() {
    document.getElementById('cart-overlay').classList.add('open');
    document.getElementById('cart-drawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    document.getElementById('cart-overlay').classList.remove('open');
    document.getElementById('cart-drawer').classList.remove('open');
    document.body.style.overflow = '';
  }

  // Close on overlay click
  var overlay = document.getElementById('cart-overlay');
  if (overlay) overlay.addEventListener('click', closeCart);

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // Cart trigger button
  var cartTrigger = document.getElementById('cart-trigger');
  if (cartTrigger) cartTrigger.addEventListener('click', openCart);

  // Cart close button
  var cartCloseBtn = document.getElementById('cart-close-btn');
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);

  // ===== SHOPIFY AJAX CART =====
  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function addItem(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function updateItem(lineItemKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace('.00', '');
  }

  function renderCart(cart) {
    var body = document.getElementById('cart-body');
    var foot = document.getElementById('cart-foot');
    var countEl = document.getElementById('cart-count');

    if (!body) return;

    var totalItems = cart.item_count || 0;
    if (countEl) countEl.textContent = totalItems;

    if (totalItems === 0) {
      body.innerHTML = '<div class="cart-empty-state"><div class="empty-icon">🐢</div><div>Your cart is empty.<br>Find your sack above.</div></div>';
      if (foot) foot.style.display = 'none';
      return;
    }

    if (foot) foot.style.display = 'block';

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image ? item.image : '';
      html += '<div class="cart-line">';
      html += '<div class="cart-line-thumb">';
      if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + item.title + '">';
      html += '</div>';
      html += '<div class="cart-line-info">';
      html += '<div class="cart-line-name">' + item.title + '</div>';
      html += '<div class="cart-line-price">' + formatMoney(item.line_price) + '</div>';
      html += '</div>';
      html += '<div class="qty-ctrl">';
      html += '<button class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>';
      html += '<span class="qty-val">' + item.quantity + '</span>';
      html += '<button class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>';
      html += '</div>';
      html += '</div>';
    });

    body.innerHTML = html;

    var totalEl = document.getElementById('cart-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Bind qty buttons
    body.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        updateItem(key, qty).then(function (updatedCart) {
          renderCart(updatedCart);
        });
      });
    });
  }

  // Add to cart buttons
  document.querySelectorAll('.add-to-cart-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = form.querySelector('[name="id"]').value;
      var btn = form.querySelector('.add-to-cart-btn');
      var originalText = btn ? btn.textContent : '';

      addItem(variantId, 1).then(function () {
        if (btn) {
          btn.textContent = '✓ Added';
          setTimeout(function () { btn.textContent = originalText; }, 1800);
        }
        return getCart();
      }).then(function (cart) {
        renderCart(cart);
        openCart();
      });
    });
  });

  // Initial cart count load
  getCart().then(function (cart) {
    var countEl = document.getElementById('cart-count');
    if (countEl) countEl.textContent = cart.item_count || 0;
  });

  // Expose openCart globally for nav button
  window.openCart = openCart;
  window.closeCart = closeCart;

});
